/**
* title: Schedule Form
**/
import { tracking } from "./organisms/tracking"

// Load all JS after Content Load
document.addEventListener('DOMContentLoaded', function () {
    tracking();
});
